module.exports = __webpack_public_path__ + "img/vr.7713173b.svg";